import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-743bb2d6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "grade-info"
};
const _hoisted_2 = {
  class: "action-box"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin-bottom": "10px",
    "width": "100%",
    "justify-content": "space-between"
  }
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_5 = {
  style: {
    "float": "right"
  }
};
const _hoisted_6 = {
  style: {
    "margin-top": "10px",
    "display": "flex",
    "justify-content": "end"
  }
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "justify-content": "center"
  }
};
const _hoisted_8 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_9 = {
  style: {
    "margin-top": "20rpx"
  }
};
const _hoisted_10 = ["innerHTML"];
import { onMounted, ref } from 'vue';
import { appStatus, classlibtTableDataSchemas } from './config';
import { useRoute, useRouter } from 'vue-router';
import { findHisApplyPlugManagePage, getHisApplyManageById, insertHisApplyPlug, previewByAppId, updateHisApply, updateHisApplyPlug, findHisApplyConfigPage, delHisApplyPlug } from '@/api/upgrade';
import Table from './components/table';
import usePagination from '@/hooks/usePagination';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getOSSClient } from '@/utils/sts';
import dayjs from 'dayjs';
export default {
  __name: 'edit',
  setup(__props) {
    const route = useRoute();
    const id = ref(route.params.id);
    const APP_TYPE_OPTIONS = ref([]);
    const appType = ref({});
    const _findHisApplyConfigPage = async () => {
      const res = await findHisApplyConfigPage({
        pageSize: 100
      });
      APP_TYPE_OPTIONS.value = res.records.map(item => {
        appType.value[item.code] = item.name;
        return {
          label: item.name,
          value: item.code
        };
      });
    };
    const form = ref({
      type: '',
      applyVersion: '',
      applyRunVersion: '',
      classRemark: ''
    });
    const hisApply = ref({});
    const loading = ref(false);
    const _getHisApplyManageById = async () => {
      loading.value = true;
      const res = await getHisApplyManageById(id.value);
      loading.value = false;
      hisApply.value = res;
      form.value = res;
    };
    const router = useRouter();
    const handleUpdateHisApply = async () => {
      await updateHisApply({
        ...form.value,
        name: appType.value[form.value.code]
      });
      ElMessage.success('替换成功');
      _getHisApplyManageById();
      router.back();
    };
    const activeName = ref('classlib');
    const tableData = ref([]);
    const {
      currentPage,
      total,
      pageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    const tableLoading = ref(false);
    const fileName = ref('');
    const _findHisApplyPlugManagePage = async () => {
      tableLoading.value = true;
      const res = await findHisApplyPlugManagePage({
        applyId: id.value,
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        fileName: fileName.value
      });
      tableLoading.value = false;
      tableData.value = res.records;
      setTotal(res.total);
    };
    const handleCurrentChange = val => {
      setCurrentPage(val);
      _findHisApplyPlugManagePage();
    };
    const current = ref(null);
    const handleReplace = row => {
      current.value = row;
      formData.value.fileVersion = row.fileVersion;
      dialogFormVisible.value = true;
    };
    const handleDel = row => {
      ElMessageBox.confirm('确认要删除吗', {
        type: 'warning'
      }).then(async () => {
        try {
          await delHisApplyPlug(row.id);
          ElMessage.success('删除成功');
          // 重新渲染数据
          _findHisApplyPlugManagePage();
        } catch (error) {
          ElMessage({
            message: error,
            type: 'error'
          });
        }
      });
      console.log('row:', row);
    };
    const dialogFormVisible = ref(false);
    const handleAddClasslivVersion = () => {
      dialogFormVisible.value = true;
    };
    const inputRef = ref(null);
    const formData = ref({
      fileName: '',
      fileVersion: ''
    });
    const handleFileUpload = () => {
      inputRef.value.click();
    };
    const file = ref(null);
    const handleChangeFile = e => {
      file.value = inputRef.value.files[0];
      console.log(file.value);
      formData.value.fileName = file.value.name;
      // formData.append(fileName, file)
      inputRef.value.value = null;
    };
    const formEl = ref(null);
    const btnLoading = ref(false);
    const handleSubmit = async e => {
      if (!formEl.value) return;
      await formEl.value.validate(async valid => {
        if (!valid) return;
        try {
          btnLoading.value = true;
          const ossClient = await getOSSClient();
          const res = await ossClient.put(`igen/${hisApply.value.name}/${form.value.applyVersion}/${formData.value.fileName.split('.')[0]}/${formData.value.fileVersion}/${formData.value.fileName}`, file.value);
          console.log('res', res);
          if (!current.value) {
            await insertHisApplyPlug({
              ...formData.value,
              fileUrl: res.url,
              applyId: id.value,
              uploadTime: dayjs(new Date()).format('YYYY-MM-DD hh:mm:ss')
            });
          } else {
            await updateHisApplyPlug({
              ...formData.value,
              fileUrl: res.url,
              applyId: id.value,
              id: current.value.id,
              uploadTime: dayjs(new Date()).format('YYYY-MM-DD hh:mm:ss')
            });
          }
          ElMessage.success(`${current.value ? '替换' : '新增'}成功`);
          dialogFormVisible.value = false;
          _findHisApplyPlugManagePage();
        } catch (error) {} finally {
          btnLoading.value = false;
          formEl.value.resetFields();
        }
      });
    };
    const dialogClose = () => {
      formData.value = {
        fileName: '',
        fileVersion: ''
      };
      current.value = null;
      formEl.value.resetFields();
    };
    const previewVisible = ref(false);
    const previewContent = ref('');
    const handlePreviewClasslibVersion = async () => {
      previewVisible.value = true;
      const res = await previewByAppId(id.value);
      console.log(res);
      previewContent.value = res.replace(/\/r\/n/g, '<br />');
    };
    onMounted(() => {
      _findHisApplyConfigPage();
      _getHisApplyManageById();
      _findHisApplyPlugManagePage();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_card, {
        shadow: "never",
        class: "grade-info-content"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "70px",
          model: form.value,
          ref_key: "formEl",
          ref: formEl,
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "应用",
            prop: "type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.value.code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.code = $event),
              style: {
                "width": "200px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(APP_TYPE_OPTIONS.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "版本号",
            prop: "applyVersion"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.applyVersion,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.applyVersion = $event),
              placeholder: "请输入版本号",
              type: "text",
              style: {
                "width": "400px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "运行版本",
            prop: "applyRunVersion"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.applyRunVersion,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.applyRunVersion = $event),
              placeholder: "请输入运行版本号",
              type: "text",
              style: {
                "width": "400px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "状态"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(appStatus)[hisApply.value['applyStatus']]), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", null, [_createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => activeName.value = $event),
          type: "card",
          size: "large",
          style: {
            "width": "800px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "类库",
            name: "classlib"
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_input, {
              modelValue: form.value.classRemark,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.classRemark = $event),
              style: {
                "width": "100%"
              },
              autosize: {
                minRows: 22
              },
              type: "textarea",
              resize: "none"
            }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
              size: "large",
              onClick: _cache[4] || (_cache[4] = $event => _ctx.$router.back())
            }, {
              default: _withCtx(() => [_createTextVNode("取消")]),
              _: 1
            }), _createVNode(_component_el_button, {
              size: "large",
              type: "primary",
              onClick: handleUpdateHisApply
            }, {
              default: _withCtx(() => [_createTextVNode("提交")]),
              _: 1
            })])])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "类库版本",
            name: "classlibVersion"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
              type: "text",
              size: "default",
              modelValue: fileName.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => fileName.value = $event),
              style: {
                "margin-right": "20px"
              }
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              type: "primary",
              onClick: _findHisApplyPlugManagePage
            }, {
              default: _withCtx(() => [_createTextVNode("搜索")]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: _cache[6] || (_cache[6] = () => {
                fileName.value = '';
                _findHisApplyPlugManagePage();
              })
            }, {
              default: _withCtx(() => [_createTextVNode("重置")]),
              _: 1
            })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
              onClick: handlePreviewClasslibVersion
            }, {
              default: _withCtx(() => [_createTextVNode("预览")]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "primary",
              onClick: handleAddClasslivVersion
            }, {
              default: _withCtx(() => [_createTextVNode("新增")]),
              _: 1
            })])]), _createVNode(_unref(Table), {
              data: tableData.value,
              currentPage: _unref(currentPage),
              pageSize: _unref(pageSize),
              onReplace: handleReplace,
              onDel: handleDel,
              loading: tableLoading.value,
              tableSchemas: _unref(classlibtTableDataSchemas)
            }, null, 8, ["data", "currentPage", "pageSize", "loading", "tableSchemas"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_pagination, {
              onCurrentChange: handleCurrentChange,
              currentPage: _unref(currentPage),
              "page-size": _unref(pageSize),
              total: _unref(total)
            }, null, 8, ["currentPage", "page-size", "total"])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      })), [[_directive_loading, loading.value]]), _createVNode(_component_el_dialog, {
        title: current.value ? '替换' : '新增',
        modelValue: dialogFormVisible.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => dialogFormVisible.value = $event),
        class: "dialog-class",
        onClosed: dialogClose,
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_form, {
          ref_key: "formEl",
          ref: formEl,
          model: formData.value
        }, {
          default: _withCtx(() => {
            var _current$value2;
            return [current.value ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "原文件",
              "label-width": 150
            }, {
              default: _withCtx(() => {
                var _current$value;
                return [_createTextVNode(_toDisplayString((_current$value = current.value) === null || _current$value === void 0 ? void 0 : _current$value.fileName), 1)];
              }),
              _: 1
            })) : _createCommentVNode("", true), (_current$value2 = current.value) !== null && _current$value2 !== void 0 && _current$value2.uploadTime ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "上传日期",
              "label-width": 150
            }, {
              default: _withCtx(() => {
                var _current$value3;
                return [_createTextVNode(_toDisplayString((_current$value3 = current.value) === null || _current$value3 === void 0 ? void 0 : _current$value3.uploadTime), 1)];
              }),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
              label: "上传文件",
              "label-width": 150,
              prop: "fileName",
              rules: [{
                required: true,
                message: '请上传文件'
              }]
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_input, {
                disabled: "",
                modelValue: formData.value.fileName,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.value.fileName = $event),
                autocomplete: "off",
                style: {
                  "width": "350px"
                }
              }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
                type: "primary",
                size: "default",
                onClick: handleFileUpload
              }, {
                default: _withCtx(() => [_createTextVNode("文件上传")]),
                _: 1
              }), _createElementVNode("input", {
                type: "file",
                ref_key: "inputRef",
                ref: inputRef,
                style: {
                  "display": "none"
                },
                onChange: handleChangeFile
              }, null, 544)])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "文件版本",
              "label-width": 150,
              prop: "fileVersion",
              rules: [{
                required: true,
                message: '文件版本不能为空'
              }]
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: formData.value.fileVersion,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formData.value.fileVersion = $event),
                autocomplete: "off",
                style: {
                  "width": "350px"
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            })];
          }),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = $event => dialogFormVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit,
          loading: btnLoading.value
        }, {
          default: _withCtx(() => [_createTextVNode("提交")]),
          _: 1
        }, 8, ["loading"])])])]),
        _: 1
      }, 8, ["title", "modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: previewVisible.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => previewVisible.value = $event),
        class: "dialog-class",
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          style: {
            "min-height": "400px"
          },
          innerHTML: previewContent.value
        }, null, 8, _hoisted_10)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};